import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import SupplierBranchUserFilters from "../../components/Filters/supplierBranchUserFilters";
import DeleteModal from "../../components/modals/DeleteModal";
import ModalSupplierBranchUser from "../../components/modals/ModalSupplierBranchUser";
import SupplierBranchUserTable from "../../components/table/SupplierBranchUserTable";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/security.model";
import {
  GetSupplierBranchUserResponse,
  SupplierBranchUserEditRequest,
  SupplierBranchUserFilter,
  SupplierBranchUserRequest,
} from "../../models/supplierUserBarnch.model";
import {
  CreateSupplierBranchUser,
  DeleteSupplierBranchUser,
  EditSupplierBranchUser,
  GetSupplierBranchUser,
  GetSupplierUserListReportExcel,
  GetAllPermissions,
} from "../../services/SupplierBranchUser.service";
import { Permissions } from "../../models/supplierUserBarnch.model";

const SupplierBranchUser = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [supplierBranchUserList, setSupplierBranchUserList] = useState<
    GetSupplierBranchUserResponse[]
  >([]);
  const [filterObject, setFilterObject] = useState<SupplierBranchUserFilter>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<
    GetSupplierBranchUserResponse
  >();
  const [supplierBranchRecord, setSupplierBranchRecord] = useState<
    GetSupplierBranchUserResponse | undefined
  >();
  const [
    openSupplierBranchUserModal,
    setOpenSupplierBranchUserModal,
  ] = useState(false);
  const [allPermissions, setAllPermissions] = useState<Permissions[]>([]);
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const history = useHistory<{
    id: number;
  }>();

  const handleDelete = (
    supplierBranchUserResponse: GetSupplierBranchUserResponse
  ) => {
    setOpenDeleteModal(true);
    setSelectedRow(supplierBranchUserResponse);
  };
  const handleDeleteRcord = () => {
    DeleteSupplierBranchUserMutate({ supplierUserId: selectedRow?.id! });
  };
  const handleAddRcord = (value: SupplierBranchUserRequest) => {
    CreateSupplierBranchUserMutate(value);
  };
  const handleExportExcel = () => {
    GetSupplierBranchUserExcelMutate({
      ...filterObject,
    });
  };
  const handleEditRecord = (row: SupplierBranchUserEditRequest) => {
    EditSupplierBranchUserMutate(row);
  };

  const handleEditBranch = (row: GetSupplierBranchUserResponse) => {
    setOpenSupplierBranchUserModal(true);
    setSupplierBranchRecord(row);
  };

  const handleRouteToBranchDetail = (rowId: number) => {
    history.push({
      pathname: "/store/SupplierBranchUser/SupplierBranchUserDetail",
      state: {
        id: rowId,
      },
    });
    localStorage.setItem("SUPPLIER_BRANCH_USERID", String(rowId));
  };
  const { mutate: CreateSupplierBranchUserMutate } = useMutation(
    CreateSupplierBranchUser,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenSupplierBranchUserModal(false);
          GetSupplierBranchUserMutate({
            filter: filterObject,
            paginationInfo: currentPaginationInfo,
          });
          toast.success("کاربر شعبه با موفقیت افزوده شد");
        }
      },
      onError: () => {},
    }
  );
  const { mutate: EditSupplierBranchUserMutate } = useMutation(
    EditSupplierBranchUser,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenSupplierBranchUserModal(false);
          GetSupplierBranchUserMutate({
            filter: filterObject,
            paginationInfo: currentPaginationInfo,
          });
          toast.success("کاربر شعبه با موفقیت ویرایش شد");
        }
      },
      onError: () => {},
    }
  );
  const { mutate: DeleteSupplierBranchUserMutate } = useMutation(
    DeleteSupplierBranchUser,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          GetSupplierBranchUserMutate({
            filter: filterObject,
            paginationInfo: currentPaginationInfo,
          });
          setOpenDeleteModal(false);
          toast.success("کاربر شعبه با موفقیت حذف گردید");
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetSupplierBranchUserMutate, isLoading } = useMutation(
    GetSupplierBranchUser,
    {
      onSuccess: (data: ApiResultModel<GetSupplierBranchUserResponse[]>) => {
        if (data) {
          setSupplierBranchUserList(data.data);
          setPageInfo(data.pageInfo);
        }
      },
      onError: () => {},
    }
  );

  const { mutate: GetAllPermissionsMutate } = useMutation(GetAllPermissions, {
    onSuccess: (data: ApiResultModel<Permissions[]>) => {
      if (data) {
        setAllPermissions(data.data);
      }
    },
    onError: () => {},
  });

  const { mutate: GetSupplierBranchUserExcelMutate } = useMutation(
    GetSupplierUserListReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  useEffect(() => {
    GetSupplierBranchUserMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Typography
              color={"#1565C0"}
              fontWeight={"bold"}
              padding={"0.5rem"}
              borderRadius={"5px"}
              sx={{
                cursor: "pointer",
                width: "fit-content",
                "&: hover": { color: "#fff", background: "#1565C0" },
              }}
              onClick={() => {
                setOpenSupplierBranchUserModal(true);
                GetAllPermissionsMutate();
              }}
            >
              <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
              افزودن کاربر
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter && (
          <Grid item xs={12} sx={{ marginBottom: "20px" }}>
            <SupplierBranchUserFilters
              setFilterObject={setFilterObject}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
            />
          </Grid>
        )}
        {/* {!isLoading ? (
          <Grid item xs={12}>
            <SupplierBranchUserTable
              supplierBranchUserList={supplierBranchUserList}
              pageInfo={pageInfo}
              currentPaginationInfo={currentPaginationInfo}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
              handelDelete={handleDelete}
              handleEdit={handleEditBranch}
              handleRouteToBranchDetail={handleRouteToBranchDetail}
            />
          </Grid>
        ) : (
          <span style={{ marginBottom: "10px", width: "100%" }}>
            <TableFiltersSkeleton />
          </span>
        )} */}
        <Grid item xs={12}>
          <SupplierBranchUserTable
            supplierBranchUserList={supplierBranchUserList}
            pageInfo={pageInfo}
            currentPaginationInfo={currentPaginationInfo}
            setCurrentPaginationInfo={setCurrentPaginationInfo}
            handelDelete={handleDelete}
            handleEdit={handleEditBranch}
            handleRouteToBranchDetail={handleRouteToBranchDetail}
          />
        </Grid>
      </Grid>
      <DeleteModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        text={
          <>
            آیا از حذف این کاربر{" "}
            <span style={{ color: "#E6123D" }}>"{selectedRow?.fullName}"</span>{" "}
            اطمینان دارید؟
          </>
        }
        handleDel={handleDeleteRcord}
        onCloseModal={() => setOpenDeleteModal(false)}
      />
      <ModalSupplierBranchUser
        handleAdd={handleAddRcord}
        openSupplierBranchUserModal={openSupplierBranchUserModal}
        setOpenSupplierBranchUserModal={setOpenSupplierBranchUserModal}
        supplierBranchRecord={supplierBranchRecord}
        setSupplierBranchRecord={setSupplierBranchRecord}
        handleEdit={handleEditRecord}
        allPermissions={allPermissions}
      />
    </div>
  );
};

export default SupplierBranchUser;
